import loadPixiApp from './cupid.js';

const breakBtn = document.getElementById('breakBtn');
const dontBreakBtn = document.getElementById('dontBreakBtn');

let app;
function refreshPixApp(isPlayBroken) {
	if (app) {
		document.body.removeChild(app.view);
	}
	app = new PIXI.Application();
	document.body.appendChild(app.view);

	loadPixiApp(app, isPlayBroken);
}

dontBreakBtn.onclick = function (event) {
	refreshPixApp(false);
};
breakBtn.onclick = function (event) {
	refreshPixApp(true);
};
